import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';

const RegistrationForm = ({ extraClass, registerStyle }) => {
    const history = useHistory();

    const [formData, setFormData] = useState({
        name: '',
        whatsapp_number: '',
        phone_number: '',
        address: '',
        profession: '',
        email: '',
        password: '',
        password_confirmation: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    // Inject CSS keyframes for loader spinner
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await axios.post(`${API_BASE_URL}/customer/register`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });

            if (response.data) {
                setSuccess('Registration successful!');
                setFormData({
                    name: '',
                    whatsapp_number: '',
                    phone_number: '',
                    address: '',
                    profession: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                });

                setTimeout(() => {
                    history.push('/login');
                }, 1500);
            }
        } catch (err) {
            if (err.response && err.response.data) {
                setError(err.response.data.message || 'Something went wrong.');
            } else {
                setError('Network error.');
            }
        }

        setLoading(false);
    };

    return (
        <div className={`newsletter-area ${registerStyle}`}>
            <div className="container">
                <div className={`row row--0 newsletter-wrapper align-items-center ${extraClass}`}>
                    <div className="col-lg-4">
                        <div className="newsletter-section-title">
                            <h2 className="title">Create an Account</h2>
                            <p className="description">Join us to get access to exclusive content and updates.</p>
                            <p>Already Have Account? <Link to='/login' className='text-primary'>LOGIN</Link></p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <form className="rn-newsletter mt_md--20 mt_sm--20" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input type="text" name="name" placeholder="Full Name" required value={formData.name} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" name="whatsapp_number" placeholder="Whatsapp Number" required value={formData.whatsapp_number} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" name="phone_number" placeholder="Phone Number" required value={formData.phone_number} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" name="address" placeholder="Address" required value={formData.address} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" name="profession" placeholder="Profession" required value={formData.profession} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="email" name="email" placeholder="Email Address" required value={formData.email} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="password" name="password" placeholder="Password" required value={formData.password} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <input type="password" name="password_confirmation" placeholder="Confirm Password" required value={formData.password_confirmation} onChange={handleChange} />
                            </div>

                            {error && <p className="text-danger">{error}</p>}
                            {success && <p className="text-success">{success}</p>}

                            <div className="form-group">
                                <button className="btn-default" disabled={loading}>
                                    Register
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Popup loader overlay */}
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        background: '#fff',
                        padding: '20px 40px',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        boxShadow: '0 0 20px rgba(0,0,0,0.2)'
                    }}>
                        <span style={{
                            width: '24px',
                            height: '24px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #3498db',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }} />
                        <span style={{ fontSize: '16px' }}>Processing registration...</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegistrationForm;
